<template>
  <ValidationObserver
    tag="form"
    @submit.prevent="addToWaitlist"
    v-slot="{ invalid }"
  >
    <HMModalHeader
      :title="$t('PRODUCTS.BUTTON.JOIN_THE_WAITLIST')"
      @close="$emit('close')"
    />
    <HMTextInput
      type="email"
      :name="$t('GENERAL.LABEL.EMAIL')"
      :placeholder="$t('PRODUCTS.LABELS.YOUR_EMAIL')"
      v-model="waitlistEmail"
    />
    <HMModalFooter
      :submitButton="$t('PRODUCTS.BUTTON.JOIN_THE_WAITLIST')"
      :loading="inProgress"
      :disabled="invalid"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import api from '@/core/api/modules/products';
import { errorToMessage } from '@/core/utils/errors';
import { mapGetters } from 'vuex';

export default {
  components: {
    ValidationObserver,
  },
  props: {
    productId: {
      type: String,
      required: true,
    },
    studioURL: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      waitlistEmail: '',
      formError: null,
      inProgress: false,
    };
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },
  methods: {
    async addToWaitlist() {
      this.inProgress = true;
      try {
        await api.addToWaitlist(
          this.studioURL,
          this.productId,
          this.waitlistEmail
        );
        this.waitlistEmail = '';
        this.$notify({
          group: 'app',
          type: 'success',
          title: this.$t(
            'PRODUCTS.ERROR.YOU_WERE_SUCCESSFULLY_ADDED_TO_THE_WAITLIST'
          ),
        });
        this.$emit('close');
      } catch (error) {
        this.$notify({
          group: 'app',
          type: 'error',
          title: this.$t('PRODUCTS.ERROR.YOUR_SUBSCRIPTION_TO_WAITLIST_FAILED'),
          text: errorToMessage(error.response, `Request failed: ${error}`),
        });
      } finally {
        this.inProgress = false;
      }
    },
  },
  mounted() {
    const email = this.user?.email;
    if (email) {
      this.waitlistEmail = email;
    }
  },
};
</script>
